<template>
    <div class="container" v-if="dataRedFila[0] && initialLoadComplete">
        <md-dialog :md-active.sync="modEditaRedFila" :md-click-outside-to-close="false" class="custom-dialog">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.title }}</span>
            </md-dialog-title>
            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <!-- Información principal -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.niif }}</label>
                            <md-field class="custom-field">
                                <md-input type="number" v-model="dataRedFila[0].niif" :placeholder="labels.niif" />
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.descripcion }}</label>
                            <md-field class="custom-field">
                                <md-input type="text" v-model="dataRedFila[0].descripcion"
                                    :placeholder="labels.descripcion" />
                            </md-field>
                        </div>
                    </div>

                    <!-- Niveles -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.primerNivel }}</label>
                            <md-field class="custom-field">
                                <md-input type="number" v-model="dataRedFila[0].primer_nivel"
                                    :placeholder="labels.primerNivel" />
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.segundoNivel }}</label>
                            <md-field class="custom-field">
                                <md-input type="number" v-model="dataRedFila[0].segundo_nivel"
                                    :placeholder="labels.segundoNivel" />
                            </md-field>
                        </div>
                    </div>

                    <!-- Configuración -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.actual }}</label>
                            <md-field class="custom-field">
                                <select v-model="dataRedFila[0].actual" class="modern-select">
                                    <option value="">{{ labels.select }}</option>
                                    <option value="1">{{ labels.yes }}</option>
                                    <option value="0">{{ labels.not }}</option>
                                </select>
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.operacion }}</label>
                            <md-field class="custom-field">
                                <select v-model="dataRedFila[0].operacion" class="modern-select">
                                    <option value="">{{ labels.select }}</option>
                                    <option value="+">{{ labels.sumar }}</option>
                                    <option value="-">{{ labels.restar }}</option>
                                </select>
                            </md-field>
                        </div>
                    </div>

                    <!-- Pestañas de selección -->
                    <div class="form-field-full">
                        <label class="field-label">{{ labels.niifSelect }}</label>
                        <div class="tabs-container">
                            <!-- Pestañas -->
                            <div class="tabs-header">
                                <button class="tab-button" :class="{ active: activeTab === 'niif' }"
                                    @click="changeTab('niif')">
                                    {{ labels.tabNiif }}
                                </button>
                                <button class="tab-button" :class="{ active: activeTab === 'redefiniciones' }"
                                    @click="changeTab('redefiniciones')">
                                    {{ labels.tabRedefiniciones }}
                                </button>
                            </div>

                            <!-- Contenido de pestañas -->
                            <div class="tab-content">
                                <!-- Pestaña NIIF -->
                                <div v-if="activeTab === 'niif'" class="niif-selection-container">
                                    <div class="search-bar">
                                        <md-field class="search-field">
                                            <md-input :placeholder="labels.searchPlaceholder" v-model="searchTerm"
                                                @input="filterNiifs" />
                                        </md-field>
                                        <div class="selection-info">
                                            {{ labels.selected }}: {{ selectedNiifs.length }} / {{ filteredNiifs.length
                                            }}
                                        </div>
                                    </div>

                                    <div class="niif-table-container">
                                        <table class="niif-table">
                                            <thead>
                                                <tr>
                                                    <th class="checkbox-column">
                                                        <md-checkbox :md-checked="selectAll"
                                                            @change="toggleSelectAll" />
                                                    </th>
                                                    <th class="niif-column sortable" @click="sortBy('niif')">
                                                        {{ labels.niif }}
                                                        <span class="sort-indicator" v-if="sortColumn === 'niif'">
                                                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="desc-column sortable" @click="sortBy('descripcion')">
                                                        {{ labels.description }}
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'descripcion'">
                                                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="level-column sortable" @click="sortBy('primer_nivel')">
                                                        {{ labels.levelFirst }}
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'primer_nivel'">
                                                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="level-desc-column sortable"
                                                        @click="sortBy('firstLevelDesc')">
                                                        {{ labels.levelFirstDesc }}
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'firstLevelDesc'">
                                                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="level-column sortable" @click="sortBy('segundo_nivel')">
                                                        {{ labels.levelSecond }}
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'segundo_nivel'">
                                                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="level-desc-column sortable"
                                                        @click="sortBy('secondLevelDesc')">
                                                        {{ labels.levelSecondDesc }}
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'secondLevelDesc'">
                                                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="niif in sortedNiifs" :key="niif.id">
                                                    <td class="checkbox-column">
                                                        <md-checkbox v-model="niif._selected"
                                                            @change="onNiifCheckboxChange(niif)"
                                                            class="custom-checkbox" />
                                                    </td>
                                                    <td class="niif-column">{{ niif.niif }}</td>
                                                    <td class="desc-column" :title="niif.nameNiif || niif.descripcion">
                                                        {{ niif.nameNiif || niif.descripcion }}
                                                    </td>
                                                    <td class="level-column">{{ niif.primer_nivel }}</td>
                                                    <td class="level-desc-column"
                                                        :title="getFirstLevelDescription(niif.primer_nivel)">
                                                        {{ getFirstLevelDescription(niif.primer_nivel) }}
                                                    </td>
                                                    <td class="level-column">{{ niif.segundo_nivel }}</td>
                                                    <td class="level-desc-column"
                                                        :title="getSecondLevelDescription(niif.niif)">
                                                        {{ getSecondLevelDescription(niif.niif) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="filteredNiifs.length === 0" class="no-results">
                                            {{ labels.noResults }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Pestaña Redefiniciones -->
                                <div v-if="activeTab === 'redefiniciones'" class="redefiniciones-selection-container">
                                    <div class="search-bar">
                                        <md-field class="search-field">
                                            <md-input :placeholder="labels.searchRedefPlaceholder"
                                                v-model="searchRedefinicion" @input="filterRedefiniciones" />
                                        </md-field>
                                        <div class="selection-info">
                                            {{ labels.selected }}: {{ selectedRedefiniciones.length }} / {{
                                            filteredRedefiniciones.length }}
                                        </div>
                                    </div>

                                    <div class="redefiniciones-table-container">
                                        <table class="redefiniciones-table">
                                            <thead>
                                                <tr>
                                                    <th class="checkbox-column">
                                                        <md-checkbox :md-checked="selectAllRedef"
                                                            @change="toggleSelectAllRedef" />
                                                    </th>
                                                    <th class="niif-column sortable" @click="sortByRedef('niif')">
                                                        {{ labels.niif }}
                                                        <span class="sort-indicator" v-if="sortColumnRedef === 'niif'">
                                                            {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="desc-column sortable"
                                                        @click="sortByRedef('descripcion')">
                                                        {{ labels.description }}
                                                        <span class="sort-indicator"
                                                            v-if="sortColumnRedef === 'descripcion'">
                                                            {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}
                                                        </span>
                                                    </th>
                                                    <th class="level-column">
                                                        {{ labels.levelFirst }}
                                                    </th>
                                                    <th class="level-column">
                                                        {{ labels.levelSecond }}
                                                    </th>
                                                    <th class="formulation-column">
                                                        {{ labels.formulacion }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="redef in sortedRedefiniciones" :key="redef.id"
                                                    class="clickable-row">
                                                    <td class="checkbox-column">
                                                        <md-checkbox v-model="redef._selected"
                                                            @change="onRedefinicionCheckboxChange(redef)"
                                                            class="custom-checkbox" />
                                                    </td>
                                                    <td class="niif-column">{{ redef.niif }}</td>
                                                    <td class="desc-column" :title="redef.descripcion">
                                                        {{ redef.descripcion }}
                                                    </td>
                                                    <td class="level-column">{{ redef.primer_nivel }}</td>
                                                    <td class="level-column">{{ redef.segundo_nivel }}</td>
                                                    <td class="formulation-column" :title="redef.formulacion">
                                                        {{ truncateFormulation(redef.formulacion) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="filteredRedefiniciones.length === 0" class="no-results">
                                            {{ labels.noRedefResults }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="dialog-actions">
                <div class="actions-left">
                    <md-button class="md-raised delete-btn" @click="confirmDelete">
                        <b-icon icon="trash" class="me-2"></b-icon>
                        {{ labels.delete }}
                    </md-button>
                </div>
                <div class="actions-right">
                    <md-button class="md-raised cancel-btn" @click="closeDialog">
                        {{ labels.close }}
                    </md-button>
                    <md-button class="md-raised md-primary save-btn" @click="confirmSave">
                        {{ labels.save }}
                    </md-button>
                </div>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import PrimerNivel from '../../../services/PrimerNivel';
import SegundoNivel from '../../../services/SegundoNivel';
import PlanConsolidacion from '../../../services/PlanConsolidacion';
import RedefinicionFila from '../../../services/RedefinicionFila';

export default {
    name: 'EditaRedefinicionFila',
    props:['modEditaRedFila','dataRedFila','vigenciaSelected','codReporte'],
    data: () => ({
        listFirstLevel: [],
        listSecondLev: [],
        listNiif: [],
        filteredNiifs: [],
        selectedNiifs: [],
        searchTerm: '',
        selectAll: false,
        originalData: null,
        hasUnsavedChanges: false,
        isSaving: false,
        initialLoadComplete: false,
        sortColumn: 'niif',
        sortDirection: 'asc',
        activeTab: 'niif',
        listRedefiniciones: [],
        filteredRedefiniciones: [],
        searchRedefinicion: '',
        sortColumnRedef: 'niif',
        sortDirectionRedef: 'asc',
        selectedRedefiniciones: [],
        selectAllRedef: false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title: "Editar redefinición fila",
                    save: "Guardar",
                    close: "Cerrar",
                    delete: "Eliminar",
                    niif: "Niif",
                    descripcion: "Descripción",
                    primerNivel: "Primer nivel",
                    segundoNivel: "Segundo nivel",
                    actual: "Actual",
                    operacion: "Operación",
                    niifSelect: "Seleccionar NIIF",
                    select: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    sumar: "Sumar",
                    restar: "Restar",
                    searchPlaceholder: "Buscar NIIF...",
                    selected: "Seleccionados",
                    levelFirst: "Nivel 1",
                    levelSecond: "Nivel 2",
                    levelFirstDesc: "Desc. Nivel 1",
                    levelSecondDesc: "Desc. Nivel 2",
                    description: "Descripción",
                    noResults: "No se encontraron resultados",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefiniciones",
                    searchRedefPlaceholder: "Buscar redefiniciones...",
                    noRedefResults: "No se encontraron redefiniciones",
                    showing: "Mostrando",
                    formulacion: "Formulación"
                }
            }else{
                return {
                    title: "Edit row redefinition",
                    save: "Save",
                    close: "Close",
                    delete: "Delete",
                    niif: "Niif",
                    descripcion: "Description",
                    primerNivel: "First level",
                    segundoNivel: "Second level",
                    actual: "Current",
                    operacion: "Operation",
                    niifSelect: "Select NIIF",
                    select: "Select...",
                    yes: "YES",
                    not: "NO",
                    sumar: "Add",
                    restar: "Subtract",
                    searchPlaceholder: "Search NIIF...",
                    selected: "Selected",
                    levelFirst: "Level 1",
                    levelSecond: "Level 2",
                    levelFirstDesc: "Level 1 Desc",
                    levelSecondDesc: "Level 2 Desc",
                    description: "Description",
                    noResults: "No results found",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefinitions",
                    searchRedefPlaceholder: "Search redefinitions...",
                    noRedefResults: "No redefinitions found",
                    showing: "Showing",
                    formulacion: "Formulation"
                }
            }
        },
        sortedNiifs() {
            if (!this.filteredNiifs.length) return [];

            return [...this.filteredNiifs].sort((a, b) => {
                let aValue, bValue;

                switch (this.sortColumn) {
                    case 'niif':
                        aValue = parseInt(a.niif);
                        bValue = parseInt(b.niif);
                        break;
                    case 'descripcion':
                        aValue = (a.nameNiif || a.descripcion || '').toLowerCase();
                        bValue = (b.nameNiif || b.descripcion || '').toLowerCase();
                        break;
                    case 'primer_nivel':
                        aValue = parseInt(a.primer_nivel);
                        bValue = parseInt(b.primer_nivel);
                        break;
                    case 'segundo_nivel':
                        aValue = parseInt(a.segundo_nivel);
                        bValue = parseInt(b.segundo_nivel);
                        break;
                    case 'firstLevelDesc':
                        aValue = this.getFirstLevelDescription(a.primer_nivel).toLowerCase();
                        bValue = this.getFirstLevelDescription(b.primer_nivel).toLowerCase();
                        break;
                    case 'secondLevelDesc':
                        aValue = this.getSecondLevelDescription(a.niif).toLowerCase();
                        bValue = this.getSecondLevelDescription(b.niif).toLowerCase();
                        break;
                    default:
                        aValue = a[this.sortColumn];
                        bValue = b[this.sortColumn];
                }

                // Manejar valores nulos o undefined
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue);
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }

                return this.sortDirection === 'desc' ? -result : result;
            });
        },
        sortedRedefiniciones() {
            if (!this.filteredRedefiniciones.length) return [];

            return [...this.filteredRedefiniciones].sort((a, b) => {
                let aValue, bValue;
                switch (this.sortColumnRedef) {
                    case 'niif':
                        aValue = parseInt(a.niif);
                        bValue = parseInt(b.niif);
                        break;
                    case 'descripcion':
                        aValue = (a.descripcion || '').toLowerCase();
                        bValue = (b.descripcion || '').toLowerCase();
                        break;
                    default:
                        aValue = a[this.sortColumnRedef];
                        bValue = b[this.sortColumnRedef];
                }

                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue);
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }

                return this.sortDirectionRedef === 'desc' ? -result : result;
            });
        }
    },
    watch: {
        dataRedFila: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && newVal[0]) {
                    this.originalData = { ...newVal[0] };
                    if (this.initialLoadComplete) {
                        this.loadSelectedNiifs();
                    }
                } else {
                    // limpiar si no hay data
                    this.selectedNiifs = [];
                    this.listNiif.forEach(n => n._selected = false);
                }
            }
        },
        'dataRedFila[0].niif'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].descripcion'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].primer_nivel'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].segundo_nivel'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].actual'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].operacion'() { this.hasUnsavedChanges = true; },
        selectedNiifs: {
            handler() {
                this.hasUnsavedChanges = true;
                this.updateSelectAllState();
            },
            deep: true
        },
        modEditaRedFila(valNew) {
            if (valNew) {
                // abrir modal -> cargar datos
                this.$nextTick(() => {
                    this.loadNiifData();
                });
            } else {
                this.searchTerm = '';
                this.selectAll = false;
                this.initialLoadComplete = false;
                // Resetear ordenamiento al cerrar
                this.sortColumn = 'niif';
                this.sortDirection = 'asc';
            }
        }
    },
    methods:{
        sortBy(column) {
            if (this.sortColumn === column) {
                // Si ya está ordenando por esta columna, cambiar dirección
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Si es una nueva columna, ordenar ascendente por defecto
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
        },

        loadNiifData() {
            // Cargar lista de NIIF
            PlanConsolidacion.getPlanConsPorCompVige(this.vigenciaSelected, this.codReporte)
                .then((res) => {
                    this.listNiif = res.data.planConsNiif || [];
                    // inicialmente todos sin seleccionar
                    this.listNiif.forEach(n => n._selected = false);
                    this.filteredNiifs = [...this.listNiif];

                    // Después marcar los seleccionados (si vienen)
                    setTimeout(() => {
                        this.loadSelectedNiifs();
                    }, 100);

                    // cargar descripciones de niveles
                    return this.loadLevelDescriptions();
                })
                .then(() => {
                    this.initialLoadComplete = true;
                })
                .catch((err) => {
                    console.log('Error cargando NIIF:', err);
                    this.filteredNiifs = [];
                    this.initialLoadComplete = true;
                });
        },
        loadSelectedNiifs() {
            if (!this.dataRedFila[0]) {
                this.selectedNiifs = [];
                this.listNiif.forEach(n => n._selected = false);
                return;
            }

            // lista desde backend (puede venir como numbers o strings)
            let selectedCodes = [];
            if (this.dataRedFila[0].listaNiif && this.dataRedFila[0].listaNiif.length > 0) {
                selectedCodes = this.dataRedFila[0].listaNiif.map(n => parseInt(n));
            } else if (this.dataRedFila[0].formulacion) {
                selectedCodes = this.extractNiifCodesFromFormulation(this.dataRedFila[0].formulacion);
            }

            // marcar flags
            this.listNiif.forEach(niif => {
                niif._selected = selectedCodes.includes(parseInt(niif.niif));
            });

            // reconstruir selectedNiifs
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
        },

        extractNiifCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const niifMatch = formulation.match(/Niif\(([^)]+)\)/i);
            if (niifMatch) {
                return niifMatch[1].split(',').map(num => parseInt(num.trim())).filter(num => !isNaN(num));
            }
            return formulation.replace(/[+-]/g, ',').split(',').map(n => parseInt(n.trim())).filter(n => !isNaN(n));
        },

        onNiifCheckboxChange(niif) {
            if (niif._selected) {
                if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
            } else {
                this.selectedNiifs = this.selectedNiifs.filter(n => n.niif !== niif.niif);
            }
            this.updateSelectAllState();
        },

        loadLevelDescriptions() {
            return new Promise((resolve) => {
                PrimerNivel.getFirstLevelByReporte(this.codReporte)
                    .then((result) => {
                        this.listFirstLevel = result.data.firstLevByReport || [];

                        const uniqueFirstLevels = [...new Set(this.listNiif
                            .filter(niif => niif.primer_nivel)
                            .map(niif => niif.primer_nivel)
                        )];

                        if (uniqueFirstLevels.length > 0) {
                            this.loadAllSecondLevelDescriptions(uniqueFirstLevels).then(resolve);
                        } else {
                            resolve();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        resolve();
                    });
            });
        },
        loadAllSecondLevelDescriptions(firstLevels) {
            return new Promise((resolve) => {
                this.listSecondLev = [];
                const promises = firstLevels.map(firstLevel =>
                    SegundoNivel.getAllLevelSecondByLevelFirstByReport(firstLevel, this.codReporte)
                        .then(res => {
                            if (res.data.secondLevByFirstLev) {
                                this.listSecondLev = [...this.listSecondLev, ...res.data.secondLevByFirstLev];
                            }
                        })
                        .catch(err => {
                            console.log(`Error loading second levels for first level ${firstLevel}:`, err);
                        })
                );

                Promise.all(promises).then(resolve);
            });
        },
        filterNiifs() {
            if (!this.searchTerm) {
                this.filteredNiifs = [...this.listNiif];
            } else {
                const term = this.searchTerm.toLowerCase();
                this.filteredNiifs = this.listNiif.filter(niif => 
                    niif.niif.toString().includes(term) ||
                    (niif.nameNiif && niif.nameNiif.toLowerCase().includes(term)) ||
                    (niif.descripcion && niif.descripcion.toLowerCase().includes(term)) ||
                    (niif.primer_nivel && niif.primer_nivel.toString().includes(term)) ||
                    (niif.segundo_nivel && niif.segundo_nivel.toString().includes(term))
                );
            }
            this.updateSelectAllState();
        },
        updateSelectAllState() {
            if (this.filteredNiifs.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiifs.every(niif => niif._selected);
        },
        toggleSelectAll() {
            if (!this.selectAll) {
                this.filteredNiifs.forEach(niif => {
                    if (!niif._selected) {
                        niif._selected = true;
                        if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
                    }
                });
                this.selectAll = true;
            } else {
                this.filteredNiifs.forEach(niif => niif._selected = false);
                this.selectedNiifs = this.selectedNiifs.filter(s => !this.filteredNiifs.some(f => f.niif === s.niif));
                this.selectAll = false;
            }
        },
        isNiifSelected(niifCode) {
            return this.selectedNiifs.some(niif => niif.niif === niifCode);
        },
        getFirstLevelDescription(levelCode) {
            if (!levelCode) return '-';
            const level = this.listFirstLevel.find(item => item.primer_nivel == levelCode);
            return level ? level.descripcion : '-';
        },
        getSecondLevelDescription(niif) {
            if (!niif) return '-';
            const level = this.listNiif.find(r_niif => r_niif.niif == niif);
            return level ? level.nameSegundoNivel : '-';
        },
        getFormulationPreview() {
            if (this.selectedNiifs.length === 0) return '-';
            const niifCodes = this.selectedNiifs.map(niif => niif.niif);
            const operation = this.dataRedFila[0].operacion || '+';
            if (niifCodes.length === 1) return niifCodes[0];
            return niifCodes.join(` ${operation} `);
        },
        restoreOriginalValues() {
            if (this.originalData && this.dataRedFila[0]) {
                Object.assign(this.dataRedFila[0], this.originalData);
                this.loadSelectedNiifs();
            }
        },
        closeDialog() {
            if (this.hasUnsavedChanges && !this.isSaving) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";
                if (window.confirm(message)) {
                    this.restoreOriginalValues();
                    this.closeModal();
                }
            } else {
                this.closeModal();
            }
        },
        confirmSave() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea guardar los cambios?"
                : "Are you sure you want to save the changes?";
            if (window.confirm(message)) {
                this.guardaRedFila();
            }
        },
        confirmDelete() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea eliminar esta fila?"
                : "Are you sure you want to delete this row?";
            if (confirm(message)) {
                this.eliminarFila();
            }
        },
        eliminarFila() {
            this.isSaving = true;
            RedefinicionFila.deleteRedefinicionFila(this.dataRedFila[0].id)
            .then((res) => {
                this.$toast.success(res.data.message);
                this.closeModal();
                this.$emit('reload');
            })
            .catch((err) => {
                console.log(err);
                this.$toast.error("Error al eliminar la fila");
            })
            .finally(() => {
                this.isSaving = false;
            });
        },
        guardaRedFila(){
            this.isSaving = true;
            const selectedNiifCodes = this.selectedNiifs.map(niif => niif.niif);
            let infoFila = {
                'id': this.dataRedFila[0].id,
                'codReporte': this.codReporte,
                'primer_nivel': this.dataRedFila[0].primer_nivel,
                'segundo_nivel': this.dataRedFila[0].segundo_nivel,
                'niif': this.dataRedFila[0].niif,
                'descripcion': this.dataRedFila[0].descripcion,
                'contable': 0,
                'cuenta': null,
                'actual': this.dataRedFila[0].actual,
                'operacion': this.dataRedFila[0].operacion,
                'formulacion': this.getFormulationPreview(),
                'listaNiif': selectedNiifCodes,
                'idUser': this.$store.state.userId
            }

            RedefinicionFila.updateRedefinicionFila(infoFila)
            .then((res) => {
                this.$toast.success(res.data.message);
                this.hasUnsavedChanges = false;
                this.closeModal();
                this.$emit('reload');
            })
            .catch((error) => {
                console.log(error);
                this.$toast.error("Error al guardar los cambios");
            })
            .finally(() => {
                this.isSaving = false;
            });
        },
        loadRedefiniciones() {
            RedefinicionFila.getAllRedefinicionFilas(this.codReporte)
                .then(res => {
                    this.listRedefiniciones = res.data.redefinicionFila || [];
                    // Filtrar para excluir la fila actual que se está editando
                    this.listRedefiniciones = this.listRedefiniciones.filter(item =>
                        item.id !== this.dataRedFila[0].id
                    );
                    // Inicializar propiedad _selected
                    this.listRedefiniciones.forEach(redef => redef._selected = false);
                    this.filteredRedefiniciones = [...this.listRedefiniciones];
                    this.selectedRedefiniciones = [];
                })
                .catch(err => {
                    console.log('Error cargando redefiniciones:', err);
                    this.listRedefiniciones = [];
                    this.filteredRedefiniciones = [];
                    this.selectedRedefiniciones = [];
                });
        },

        filterRedefiniciones() {
            if (!this.searchRedefinicion) {
                this.filteredRedefiniciones = [...this.listRedefiniciones];
            } else {
                const term = this.searchRedefinicion.toLowerCase();
                this.filteredRedefiniciones = this.listRedefiniciones.filter(item =>
                    item.niif.toString().includes(term) ||
                    (item.descripcion && item.descripcion.toLowerCase().includes(term))
                );
            }
        },

        sortByRedef(column) {
            if (this.sortColumnRedef === column) {
                this.sortDirectionRedef = this.sortDirectionRedef === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumnRedef = column;
                this.sortDirectionRedef = 'asc';
            }
        },

        onRedefinicionSelect(redefinicion) {
            const niifCodes = this.extractNiifCodesFromFormulation(redefinicion.formulacion);

            this.listNiif.forEach(niif => {
                niif._selected = niifCodes.includes(parseInt(niif.niif));
            });
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
            this.activeTab = 'niif';
            this.hasUnsavedChanges = true;
        },
        truncateFormulation(formulation) {
            if (!formulation) return '';
            if (formulation.length > 50) {
                const niifMatch = formulation.match(/^(Niif\([^)]+\))/i);
                if (niifMatch) {
                    const niifPart = niifMatch[1];
                    if (niifPart.length > 50) {
                        const numbersMatch = niifPart.match(/Niif\(([^)]+)\)/i);
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(',');
                            if (numbers.length > 8) {
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5),
                                    '...',
                                    ...numbers.slice(-3)
                                ].join(',');
                                return `Niif(${truncatedNumbers})`;
                            }
                        }
                    }
                    return niifPart;
                }
                return formulation.substring(0, 50) + '...';
            }
            return formulation;
        },
        onRedefinicionCheckboxChange(redef) {
            if (redef._selected) {
                if (!this.selectedRedefiniciones.some(r => r.id === redef.id)) {
                    this.selectedRedefiniciones.push(redef);
                }
            } else {
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(r => r.id !== redef.id);
            }
            this.updateSelectAllRedefState();
            this.applyRedefinicionesSelection();
        },

        // Aplicar selección de redefiniciones a NIIFs
        applyRedefinicionesSelection() {
            if (this.selectedRedefiniciones.length === 0) return;

            // Recolectar todos los NIIFs únicos de las redefiniciones seleccionadas
            const allNiifCodes = new Set();

            this.selectedRedefiniciones.forEach(redef => {
                const niifCodes = this.extractNiifCodesFromFormulation(redef.formulacion);
                niifCodes.forEach(code => allNiifCodes.add(code));
            });

            // Convertir Set a Array
            const uniqueNiifCodes = Array.from(allNiifCodes);

            // Marcar los NIIFs correspondientes
            this.listNiif.forEach(niif => {
                niif._selected = uniqueNiifCodes.includes(parseInt(niif.niif));
            });

            // Actualizar lista de seleccionados
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
            this.hasUnsavedChanges = true;
        },

        // Seleccionar todas las redefiniciones filtradas
        toggleSelectAllRedef() {
            if (!this.selectAllRedef) {
                // Marcar todas
                this.filteredRedefiniciones.forEach(redef => {
                    if (!redef._selected) {
                        redef._selected = true;
                        if (!this.selectedRedefiniciones.some(r => r.id === redef.id)) {
                            this.selectedRedefiniciones.push(redef);
                        }
                    }
                });
                this.selectAllRedef = true;
            } else {
                // Desmarcar todas
                this.filteredRedefiniciones.forEach(redef => redef._selected = false);
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(
                    s => !this.filteredRedefiniciones.some(f => f.id === s.id)
                );
                this.selectAllRedef = false;
            }
            this.applyRedefinicionesSelection();
        },

        // Actualizar estado de "seleccionar todos" para redefiniciones
        updateSelectAllRedefState() {
            if (this.filteredRedefiniciones.length === 0) {
                this.selectAllRedef = false;
                return;
            }
            this.selectAllRedef = this.filteredRedefiniciones.every(redef => redef._selected);
        },

        // Al cambiar de pestaña, limpiar selección de redefiniciones si no hay NIIFs seleccionados
        changeTab(tab) {
            this.activeTab = tab;
            if (tab === 'redefiniciones' && this.listRedefiniciones.length === 0) {
                this.loadRedefiniciones();
            }
            // Limpiar selección de redefiniciones si no hay NIIFs seleccionados
            if (tab === 'redefiniciones' && this.selectedNiifs.length === 0) {
                this.clearRedefinicionesSelection();
            }
        },

        // Limpiar selección de redefiniciones
        clearRedefinicionesSelection() {
            this.selectedRedefiniciones = [];
            this.listRedefiniciones.forEach(redef => redef._selected = false);
            this.selectAllRedef = false;
        },
        closeModal(){
            this.$emit('cierraModal',false);
        }
    },
    mounted() {
        if (this.codReporte) {
            PrimerNivel.getFirstLevelByReporte(this.codReporte)
                .then((result) => {
                    this.listFirstLevel = result.data.firstLevByReport || [];
                })
                .catch((err) => {
                    console.log(err)
                })
        }

        if (this.modEditaRedFila && this.dataRedFila[0]) {
            this.$nextTick(() => {
                this.loadNiifData();
            });
        }
    }
}
</script>

<style scoped>
/* Estilos base */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    border-bottom: 1px solid #2c3e50;
}
.header-title { font-size: 1.3rem; font-weight: 500; }
.dialog-content { padding: 20px 24px; max-height: 80vh; overflow-y: auto; }
.form-container { display: flex; flex-direction: column; gap: 20px; }
.form-group { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.form-field-full { width: 100%; }

/* Labels y campos */
.field-label { 
    display: block; font-weight: 600; color: #2c3e50; margin-bottom: 8px; 
    font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; 
}
.custom-field { margin: 0; }
.modern-select { 
    width: 100%; padding: 12px 16px; border: 1px solid #bdc3c7; border-radius: 4px; 
    background: white; font-size: 14px; color: #2c3e50; outline: none; 
    transition: border-color 0.2s ease; 
}
.modern-select:focus { border-color: #3498db; box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1); }

/* Pestañas */
.tabs-container { border: 1px solid #e9ecef; border-radius: 4px; overflow: hidden; }
.tabs-header { display: flex; background: #f8f9fa; border-bottom: 1px solid #e9ecef; }
.tab-button { 
    flex: 1; padding: 12px 16px; background: none; border: none; 
    border-bottom: 3px solid transparent; font-weight: 600; color: #6c757d; 
    cursor: pointer; transition: all 0.3s ease; font-size: 14px; 
    text-transform: uppercase; letter-spacing: 0.5px; 
}
.tab-button:hover { background: #e9ecef; color: #495057; }
.tab-button.active { color: #3498db; border-bottom-color: #3498db; background: white; }
.tab-content { background: white; }

/* Barras de búsqueda comunes */
.search-bar { 
    display: flex; justify-content: space-between; align-items: center; 
    padding: 12px 16px; background: #f8f9fa; border-bottom: 1px solid #e9ecef; 
}
.search-field { margin: 0; flex: 1; max-width: 300px; }
.selection-info { color: #6c757d; font-size: 14px; font-weight: 500; }

/* Tablas comunes */
.niif-table-container, .redefiniciones-table-container { 
    max-height: 400px; overflow-y: auto; 
}
.niif-table, .redefiniciones-table { 
    width: 100%; border-collapse: collapse; background: white; font-size: 13px; 
}
.niif-table thead, .redefiniciones-table thead { 
    position: sticky; top: 0; z-index: 100; 
}
.niif-table th, .redefiniciones-table th { 
    background: #34495e; color: white; padding: 8px 4px; text-align: left; 
    font-weight: 600; font-size: 12px; text-transform: uppercase; 
    white-space: nowrap; border-bottom: 2px solid #2c3e50; 
}
.niif-table td, .redefiniciones-table td { 
    padding: 4px 4px; border-bottom: 1px solid #e9ecef; 
    line-height: 1.2; vertical-align: middle; 
}
.niif-table tr, .redefiniciones-table tr { height: 28px; }
.niif-table tr:hover, .redefiniciones-table tr:hover { background: #f8f9fa; }

/* Columnas ordenables */
.sortable { 
    cursor: pointer; transition: background-color 0.2s ease; 
    user-select: none; position: relative; 
}
.sortable:hover { background: #2c3e50; }
.sort-indicator { margin-left: 4px; font-weight: bold; font-size: 12px; }

/* Columnas específicas */
.checkbox-column, .action-column { width: 50px; text-align: center; padding: 0 2px; }
.niif-column { width: 70px; font-weight: 600; color: #2c3e50; text-align: center; }
.desc-column { 
    width: 180px; min-width: 180px; max-width: 180px; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
}
.level-column { width: 60px; text-align: center; font-weight: 600; }
.level-desc-column { 
    width: 140px; min-width: 140px; max-width: 140px; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 12px; 
}
.formulation-column { 
    width: 200px; min-width: 200px; max-width: 200px; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
    font-size: 11px; color: #6c757d; 
}

/* Componentes específicos */
.custom-checkbox { margin: 0; }
:deep(.custom-checkbox.md-checked .md-checkbox-container) { 
    background: #e74c3c !important; border-color: #e74c3c !important; 
}
:deep(.custom-checkbox.md-checked .md-checkbox-container::after) { 
    border-color: white !important; 
}
.select-btn { margin: 0; padding: 0; min-width: 30px; height: 30px; }
:deep(.select-btn .md-ripple) { padding: 4px; }
:deep(.select-btn .b-icon) { font-size: 16px; color: #3498db; }
.clickable-row { cursor: pointer; transition: background-color 0.2s ease; }
.clickable-row:hover { background: #e3f2fd !important; }

/* Estados y mensajes */
.no-results { 
    padding: 20px; text-align: center; color: #6c757d; 
    font-style: italic; font-size: 14px; 
}

/* Acciones del diálogo */
.dialog-actions { 
    padding: 16px 24px; border-top: 1px solid #ecf0f1; 
    display: flex; justify-content: space-between; align-items: center; 
    gap: 12px; background: #f8f9fa; 
}
.actions-left, .actions-right { display: flex; }
.actions-right { gap: 12px; }

/* Botones */
.delete-btn { background: #e74c3c !important; color: white !important; }
.cancel-btn { background: #95a5a6 !important; color: white !important; }
.save-btn { background: #3498db !important; color: white !important; }
.delete-btn, .cancel-btn, .save-btn { 
    font-size: 14px; padding: 8px 16px; min-width: 90px; 
}
.delete-btn:hover { background: #c0392b !important; }
.cancel-btn:hover { background: #7f8c8d !important; }
.save-btn:hover { background: #2980b9 !important; }

/* Scroll personalizado */
.niif-table-container::-webkit-scrollbar,
.redefiniciones-table-container::-webkit-scrollbar { width: 6px; }
.niif-table-container::-webkit-scrollbar-track,
.redefiniciones-table-container::-webkit-scrollbar-track { background: #f1f1f1; }
.niif-table-container::-webkit-scrollbar-thumb,
.redefiniciones-table-container::-webkit-scrollbar-thumb { 
    background: #c1c1c1; border-radius: 3px; 
}
.niif-table-container::-webkit-scrollbar-thumb:hover,
.redefiniciones-table-container::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }

/* Tooltips */
.desc-column:hover::after, .level-desc-column:hover::after, 
.formulation-column:hover::after { 
    content: attr(title); position: absolute; background: #333; color: white; 
    padding: 4px 8px; border-radius: 4px; font-size: 12px; z-index: 1000; 
    white-space: normal; max-width: 300px; 
}

/* Responsive */
@media (max-width: 768px) {
    .form-group { grid-template-columns: 1fr; gap: 16px; }
    .form-container { padding: 16px; }
    .dialog-actions { 
        padding: 12px 16px; flex-direction: column; gap: 10px; 
    }
    .actions-left, .actions-right { width: 100%; justify-content: center; }
    .delete-btn, .cancel-btn, .save-btn { 
        width: 100%; font-size: 13px; padding: 10px; 
    }
    .search-bar { flex-direction: column; gap: 10px; align-items: stretch; }
    .search-field { max-width: 100%; }
    .niif-table-container, .redefiniciones-table-container { max-height: 300px; }
    .tabs-header { flex-direction: column; }
    .tab-button { 
        text-align: center; border-bottom: 1px solid #e9ecef; border-right: none; 
    }
    .tab-button.active { 
        border-bottom: 3px solid #3498db; border-right: none; 
    }
    .desc-column, .level-desc-column, .formulation-column { 
        max-width: 120px; min-width: 120px; 
    }
}
</style>
